import $ from 'jquery';
import fullpage from '../lib/fullpage';
import counters from '../components/_counters';
import history from '../blocks/_history-blocks';
import hw_banners from '../blocks/_halfwidth-banner';
import ff_banners from '../blocks/_fullwidth-banner-foldable';
import profile from '../blocks/_profile-blocks';
import brands from '../blocks/_brand-columns';
import fw_content from '../blocks/_fullwidth_content_container';

let fp;
$(document).ready(function () {
    // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
    let vh = window.innerHeight * 0.01;
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--vh', `${vh}px`);
    // move footer on the bottom
    $("<section class='footer-section section fp-auto-height'></section>").appendTo("#main");
    $('#footer').appendTo(".footer-section");
    let args = {
        licenseKey: '9DBEC8D9-51474611-A5A2D298-1E695D07',
        scrollingSpeed: 700,
        fixedElements: '#masthead, .block-history-blocks-timeline, #blocks-top-navigation, .srg-modal',
        scrollBar: false,
        loopBottom: false,
        loopTop: false,
        loopHorizontal: false,
        touchSensitivity: 15,
        normalScrollElements: '.srg-files-list, .srg-slick-files-slide, .srg-posts-list, .positions-list, .srg-modal',
        // scrollOverflow: true,
        afterRender: function () {
            $('#page').addClass('fp_rendered');
        },
        onLeave: function (origin, destination, direction) {
            history.fixTimeline(origin, direction);
            counters.initCounters(destination);
        }
    }

    let $history_blocks = $('.block-history-blocks');
    if ($history_blocks.length) {
        let anchors = [''];
        $history_blocks.each(function () {
            let id = $(this).find('.block-history-block-container').attr('id').replace('year_', '');
            anchors = anchors.concat([id]);
        })
        args['anchors'] = anchors;
    }

    let $body = $('body');
    // Do not inti fullpage.js on specific pages
    if (!$body.hasClass('page-template-page-privacy') &&
        !$body.hasClass('page-template-page-cookies') &&
        !($body.hasClass('investors') && $(window).width() < 992) &&
        !($body.hasClass('single-post') && $(window).width() < 992) &&
        !$body.hasClass('search')
    ) {
        // fix each section content based on device width before init fullpage.js
        fixMobileSections();
        fp = new fullpage('#main', args);
        $('.btn-scroll-down').click(function() {
            fullpage_api.moveSectionDown();
        })
    }
});

function fixMobileSections() {
    hw_banners.fixMobileSectionsFp();
    ff_banners.fixMobileSectionsFp();
    profile.fixMobileSectionsFp();
    brands.fixMobileSectionsFp();
    fw_content.fixMobileSectionsFp();
}